import { DEFAULT_GEO_CRS } from 'app/config/constants';

export interface GeoPoint {
  lat: number;
  lon: number;
  crs?: string;
}

export function coordToString(point: GeoPoint, defaultVal = ''): string {
  return point?.lat && point?.lon ? `${point.lat}, ${point.lon}` : defaultVal;
}

export function stringToCoord(point: string, defaultVal = null): GeoPoint {
  if (!point || !point.includes(',')) {
    return defaultVal;
  }
  const [lat, lon] = point.split(',').map(parseFloat);
  return { lat, lon, crs: DEFAULT_GEO_CRS };
}
